import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { categories } from '@services/api'

import { hashCategories } from '@utils/index'

export class categoriesStore extends StoreExt {
    @observable selectedCategories = []
    @observable indexedParents = {}
    @observable indexedCategories = {}
    @observable relatedTo = []
    @observable relatedCategories = []
    @observable list = []
    @observable type = null
    @observable editing = false
    typesRestriction = {
        HEALTH_RIGHT: false,
        POLICY: true,
        USER_AREA: true
    }

    @action
    updateCategoriesList = async (type, fields) => {
        const rawCategories = await categories.getList({ type, fields })
        const { indexedParents, indexedCategories } = hashCategories(rawCategories.data)
        runInAction(() => {
            this.type = type
            this.editing = this.typesRestriction[type]
            this.list = rawCategories.data
            this.indexedParents = indexedParents
            this.indexedCategories = indexedCategories
        })
    }

    @action
    updateSelectedCategories = async categories => {
        this.selectedCategories = categories
    }

    @action
    updateSelectedByCategory = async categoryId => {
        let selectedParents = []
        const categoryList = this.indexedCategories

        function addToChain(childId) {
            selectedParents.unshift(categoryList[childId])
            if (categoryList[childId]['parent_id']) {
                addToChain(categoryList[childId]['parent_id'])
            }
        }

        if (categoryId) {
            addToChain(categoryId)
        } else {
            selectedParents = [{ id: null }]
        }
        this.selectedCategories = selectedParents
    }

    @action
    resetSelectedCategories = () => {
        this.selectedCategories = []
    }

    @action
    getRelatedCategories = async id => {
        const { relatedCategories, relatedTo } = (await categories.getRefs(id)).data
        runInAction(() => {
            this.relatedTo = relatedTo
            this.relatedCategories = relatedCategories
        })
    }
}

export default remotedev(new categoriesStore())
